var searchAutobahn = require('integrations/search');

var turntoSearch = require('./integrations/turnto/search');
searchAutobahn.baseFiles.initTurntoSiteIntegrations = turntoSearch?.initTurntoSiteIntegrations;

module.exports = searchAutobahn;
